import axios from '../../utils/AxiosUtils';
import { push } from 'connected-react-router';
import i18n from '../../i18next';
import {
    DEFAULT_BRAND_NAME,
    DEFAULT_BRAND_DESCRIPTION,
    DEFAULT_BRAND_CATEGORY_ID,
    DEFAULT_BRAND_THEME,
    DEFAULT_PAGE_SIZE
} from '../../utils/Constants';
import MessageUtils from "../../utils/MessageUtils";
import {
    LOADING,
    CREATE_BRAND_SUCCESS,
    UPDATE_BRAND_SUCCESS,
    LOAD_BRAND_SUCCESS,
    LOAD_BRANDS_SUCCESS,
    CLEAR_BRANDS,
    CLEAR_BRAND,
    UPDATE_BRAND_IMAGE_SUCCESS,
    UPDATE_BRAND_LOGO_SUCCESS,
    DELETE_BACKGROUND_IMAGE_SUCCESS
} from '../types';
import { redirectToPageNotFound } from "../../utils/CommonUtils";

export const createBrand = () => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-chain`;

        const brandData = {
            name: DEFAULT_BRAND_NAME,
            categories: [{
                id: DEFAULT_BRAND_CATEGORY_ID
            }],
            description: DEFAULT_BRAND_DESCRIPTION,
            customerFrontEndTheme: {
                type: DEFAULT_BRAND_THEME
            }
        }

        axios().post(url, brandData)
            .then(response => createBrandSuccess(dispatch, response))
            .catch((error) => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:brandsActions.createFailure')));

    }
}

const createBrandSuccess = (dispatch, response) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:brandsActions.createSuccess'));

    const brand = response.data.data[0];
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: CREATE_BRAND_SUCCESS, payload: brand });
    dispatch(push(`/brand/${brand.id}`));
}

export const updateBrand = (state, backgroundFilePath) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });

        const currentChain = state.brand;
        const url = `/restaurant-chain/${currentChain.id}`;

        // Resets theme colors so that it does not send DARK or LIGHT theme with custom colors
        let theme = { type: currentChain.customerFrontEndThemeType ? currentChain.customerFrontEndThemeType : state.brand.customerFrontEndTheme.type };

        if (theme.type === 'CUSTOM') {

            theme = {
                ...theme,
                primaryColor: currentChain.customerFrontEndTheme.primaryColor,
                secondaryColor: currentChain.customerFrontEndTheme.secondaryColor,
                mainTextColor: currentChain.customerFrontEndTheme.mainTextColor,
                inactiveColor: currentChain.customerFrontEndTheme.inactiveColor,
                primaryHover: currentChain.customerFrontEndTheme.primaryHover,
                secondaryHover: currentChain.customerFrontEndTheme.secondaryHover,
                buttonOutline: currentChain.customerFrontEndTheme.buttonOutline,
                customScrollbar: currentChain.customerFrontEndTheme.customScrollbar,
                regularText: currentChain.customerFrontEndTheme.regularText,
                restInfoBackground: currentChain.customerFrontEndTheme.restInfoBackground,
                menuBackground: currentChain.customerFrontEndTheme.menuBackground,
                menuItemsBackground: currentChain.customerFrontEndTheme.menuItemsBackground,
                chefNoteBackground: currentChain.customerFrontEndTheme.chefNoteBackground,
                primaryFontColor: currentChain.customerFrontEndTheme.primaryFontColor,
                mainTextColor: currentChain.customerFrontEndTheme.mainTextColor,
                inputsFontColor: currentChain.customerFrontEndTheme.inputsFontColor,
                inputsPlaceholderColor: currentChain.customerFrontEndTheme.inputsPlaceholderColor,
                backGroundImageFilePath: backgroundFilePath ? backgroundFilePath : currentChain.customerFrontEndTheme.backGroundImageFilePath,
                imageBackground: currentChain.customerFrontEndTheme.imageBackground,
                menuuLogoColor: currentChain.customerFrontEndTheme.menuuLogoColor,
                buttonsFont: currentChain.customerFrontEndTheme.buttonsFont,
                upsellBackground: currentChain.customerFrontEndTheme.upsellBackground,
                upsellPrimaryFont: currentChain.customerFrontEndTheme.upsellPrimaryFont,
                upsellSecondaryFont: currentChain.customerFrontEndTheme.upsellSecondaryFont,
                tableHeadersBackground: currentChain.customerFrontEndTheme.tableHeadersBackground,
                tableHeadersFont: currentChain.customerFrontEndTheme.tableHeadersFont,
                fontFamily: currentChain.customerFrontEndTheme.fontFamily,
                fontWeight: currentChain.customerFrontEndTheme.fontWeight,
                fontStyle: currentChain.customerFrontEndTheme.fontStyle,
                fontVariant: currentChain.customerFrontEndTheme.fontVariant,
                badgeFontColor: currentChain.customerFrontEndTheme.badgeFontColor
            }
        }

        const brand = {
            id: currentChain.id,
            name: currentChain.name,
            categories: currentChain.categories,
            description: currentChain.description,
            customerFrontEndTheme: theme,
            webSite: currentChain.webSite,
            manager: state.manager,
            admin: state.admin,
            bannerImagePath: state.brand.bannerImagePath,
            smallLogoFilePath: state.brand.smallLogoFilePath,
            googleTagManagerId: state.brand.googleTagManagerId,
            googleTagManagerIdIos: state.brand.googleTagManagerIdIos,
            skipLocationStep: state.brand.skipLocationStep,
            chainLevelPromotionSettings: state.brand.chainLevelPromotionSettings,
            firebaseProjectName: state.brand.firebaseProjectName ? state.brand.firebaseProjectName : null
        }

        const brandId = state.brand.id,
            imageFormData = state.imageFormData,
            brandLogoFormData = state.brandLogoFormData;

        axios().put(url, brand)
            .then(response => updateBrandSuccess(dispatch, response, getState, brandId, imageFormData, brandLogoFormData))
            .catch(error => updateBrandError(dispatch, error));
    }
}

const updateBrandSuccess = (dispatch, response, getState, brandId, imageFormData, brandLogoFormData) => {
    dispatch({ type: UPDATE_BRAND_SUCCESS, payload: response.data });
    dispatch({ type: LOADING, payload: false });

    if (imageFormData != null || brandLogoFormData != null) {

        if (imageFormData !== null && brandLogoFormData !== null) { // Both IMAGE and LOGO
            doUploadBannerImage(brandId, imageFormData, dispatch, getState, () => uploadBrandLogo(dispatch, getState, brandId, brandLogoFormData));
        } else if (imageFormData !== null && !brandLogoFormData) { // Only IMAGE 
            doUploadBannerImage(brandId, imageFormData, dispatch, getState);
        } else if (brandLogoFormData !== null && !imageFormData) { // Only LOGO
            uploadBrandLogo(dispatch, getState, brandId, brandLogoFormData);
        }
    } else {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:brandsActions.saveSuccess'));
    }
}

const uploadBrandLogo = (dispatch, getState, brandId, brandLogoFormData) => {
    dispatch({ type: LOADING, payload: true });

    const formData = brandLogoFormData;
    const url = `/restaurant-chain/${brandId}/upload-logo`;

    let newFormData = new FormData();
    newFormData.append('file', formData);

    axios().put(url, newFormData)
        .then(response => uploadBrandLogoSuccess(dispatch, response))
        .catch(error => updateBrandError(dispatch, error));
}

const uploadBrandLogoSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_BRAND_LOGO_SUCCESS, payload: response.data });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:brandsActions.saveSuccess'));
}

const updateBrandError = (dispatch, error) => {
    dispatch({ type: LOADING, payload: false });

    if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:brandsActions.saveFailure'))
    } else {
        console.log(error);
    }
}

export const loadBrand = (id) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-chain/${id}`;

        axios().get(url)
            .then(response => (response.status === 204) ? redirectToPageNotFound(dispatch) : loadBrandSuccess(dispatch, response))
            .catch(error => console.log('error', error))
    }
}

const loadBrandSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_BRAND_SUCCESS, payload: response.data });
}

export const loadBrands = (currentPageNumber = 1, searchQuery) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        let brandNameParameter = '';
        let managerNameParameter = '';
        let managerEmailParameter = '';

        if (searchQuery !== undefined) {
            if (searchQuery.brandName !== undefined && searchQuery.brandName !== '') {
                brandNameParameter = `&chainName=${searchQuery.brandName}`
            }
            if (searchQuery.managerName !== undefined && searchQuery.managerName !== '') {
                managerNameParameter = `&managerName=${searchQuery.managerName}`
            }
            if (searchQuery.managerEmail !== undefined && searchQuery.managerEmail !== '') {
                managerEmailParameter = `&managerEmail=${searchQuery.managerEmail}`
            }
        }

        const url = `/restaurant-chain/search?page=${currentPageNumber - 1}&size=${DEFAULT_PAGE_SIZE}${brandNameParameter}${managerNameParameter}${managerEmailParameter}`;

        axios().get(url)
            .then(response => loadBrandsSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(
                dispatch, error.response.data, i18n.t('actions:brandsActions.brandsLoadFailure')));
    }
}

const loadBrandsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_BRANDS_SUCCESS, payload: response.data });
}

export const clearBrands = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_BRANDS });
    }
}

export const clearBrand = () => {
    return (dispatch) => {
        dispatch({ type: CLEAR_BRAND });
    }
}

export const uploadBannerImage = (brandId, formData) => {
    return (dispatch, getState) => {
        doUploadBannerImage(brandId, formData, dispatch, getState);
    }
}

const doUploadBannerImage = (brandId, formData, dispatch, getState, callback) => {
    const newFormData = new FormData();

    newFormData.append('file', formData);

    const url = `/restaurant-chain/${brandId}/upload-banner`;
    const header = { headers: { 'Content-Type': 'multipart/form-data' } }

    axios().put(url, newFormData, header)
        .then(response => uploadBrandImageSuccess(dispatch, response, callback))
        .catch(error => uploadBrandImageFailure(dispatch, error));
}

const uploadBrandImageSuccess = (dispatch, response, callback) => {
    if (callback) {
        callback();
    }
    dispatch({ type: UPDATE_BRAND_IMAGE_SUCCESS, payload: response.data });
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:brandsActions.saveSuccess'));
}

const uploadBrandImageFailure = (dispatch, _) => {
    MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:brandsActions.uploadImageFailure'));
}

export const uploadBackgroundImage = (state) => {
    return (dispatch) => {

        const currentChain = state.brand;
        const file = currentChain.customerFrontEndTheme.backGroundImageFilePath;
        const url = `/restaurant-chain/${currentChain.id}/background-image`;

        let newFormData = new FormData();
        newFormData.append('file', file)

        axios().put(url, newFormData)
            .then(response => dispatch(updateBrand(state, response.data.customerFrontEndTheme.backGroundImageFilePath)))
            .catch(error => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:brandsActions.uploadBackgroundImageFailure')))
    }
}

export const deleteBackgroundImage = (themeId) => {
    return (dispatch) => {

        const url = `/theme/${themeId}/delete-image`;

        axios().delete(url)
            .then(response => {
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:brandsActions.deleteBackgroundImageSuccess'))
                dispatch({ type: DELETE_BACKGROUND_IMAGE_SUCCESS, payload: response.data })
            })
            .catch(error => MessageUtils.dispatchErrorMessage(dispatch, i18n.t('actions:brandsActions.deleteBackgroundImageFailure')))
    }
}


// WEBPACK FOOTER //
// ./src/actions/brands/BrandsActions.js